import ComingSoon from "../components/ComingSoon";

const ITEMS = [
  { kind: "Sector guide", title: "Healthcare", body: "Clinical-grade governance for AI that touches patient outcomes — covering subgroup performance, automation bias, and post-deployment drift." },
  { kind: "Sector guide", title: "Finance", body: "Model-risk discipline for modern AI — adverse-action explanations, feature lineage, foundation-model concentration risk." },
  { kind: "Sector guide", title: "Manufacturing", body: "Vision and prediction systems that earn worker trust — scoping, safety-vs-monitoring separation, operator override logging." },
  { kind: "Sector guide", title: "Public sector", body: "Decision-affecting AI in government — procurement standards, redress mechanisms, and the Irish operating context." },
  { kind: "Sector guide", title: "Legal & professional services", body: "Generative AI in law and audit — verification, privilege, and the supervisory expectations now emerging." },
  { kind: "Sector guide", title: "Education", body: "AI in teaching and assessment — student protection, transparency, and the EU AI Act's emotion-recognition prohibition." },
];

export default function Industries() {
  return (
    <ComingSoon
      kicker="Industry-Specific Guides"
      title="Different sectors, different stakes — different answers."
      lede="Sector-specific operating guidance translates the EU AI Act and adjacent regimes into the language, regulations, and realities of each industry. Six guides are in development."
      items={ITEMS}
    />
  );
}
